"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _featuredDocumentItem = _interopRequireDefault(require("../../legacy/featured-document-item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  /** class name for the component */
  className: _propTypes.string,

  /** Array of documents to display */
  documentsList: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.string), _propTypes.func]),

  /** html id for the component */
  htmlId: _propTypes.string
};

var FeatureDocumentListing = function FeatureDocumentListing(_ref) {
  var className = _ref.className,
      htmlId = _ref.htmlId,
      documentsList = _ref.documentsList;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    className: className,
    flexDirection: "column",
    id: htmlId,
    mb: [5, "64px"],
    width: 1
  }, (0, _utils.mapIndexed)(function (props) {
    return /*#__PURE__*/_react["default"].createElement(_featuredDocumentItem["default"], props);
  }, documentsList));
};

FeatureDocumentListing.propTypes = propTypes;
FeatureDocumentListing.displayName = "Modules.FeatureDocumentListing";
var _default = FeatureDocumentListing;
exports["default"] = _default;